export default "__VITE_ASSET__F3fsUzRm__"